export default "__VITE_ASSET__bd43a4cb__"